import { KibsiClient } from './base';
const SERVICE = 'application';
export class ApplicationKibsiClient extends KibsiClient {
    constructor(params) {
        super(params, SERVICE);
    }
    list(paginationRequest, requestConfig) {
        const { continuationToken, pageSize, sort, criteria } = paginationRequest || {};
        const { ids, published, q } = criteria ?? {};
        return this.get('/apps', {
            ...(paginationRequest && {
                params: { continuationToken, pageSize, sort, ids: ids?.join(','), published, q },
            }),
            ...requestConfig,
        });
    }
    read(entityId, requestConfig) {
        return this.get(`/apps/${entityId}`, requestConfig);
    }
    create(entity, requestConfig) {
        return this.post(`/apps/`, entity, requestConfig);
    }
    update(entity, requestConfig) {
        return this.put(`/apps/${entity.id}`, entity, requestConfig);
    }
    delete(entity, requestConfig) {
        return this.del(`/apps/${entity.id}`, requestConfig);
    }
    readModelDefinition(entityId, requestConfig) {
        return this.get(`/apps/${entityId}/modeldefinition`, requestConfig);
    }
    updateModelDefinition(entityId, definition, requestConfig) {
        return this.put(`/apps/${entityId}/modeldefinition`, definition, requestConfig);
    }
    listVersions(paginationRequest, requestConfig) {
        const { continuationToken, pageSize, sort, criteria } = paginationRequest || {};
        const { versionIds } = criteria ?? {};
        return this.get(`/versions`, {
            ...requestConfig,
            params: { continuationToken, pageSize, sort, versionIds: versionIds?.join(',') },
        });
    }
    listApplicationVersions(applicationId, paginationRequest, requestConfig) {
        const { continuationToken, pageSize, sort, criteria } = paginationRequest || {};
        const { versionIds } = criteria ?? {};
        return this.get(`/apps/${applicationId}/versions`, {
            ...requestConfig,
            params: { continuationToken, pageSize, sort, versionIds: versionIds?.join(',') },
        });
    }
    createVersion(applicationId, entity, requestConfig) {
        return this.post(`/apps/${applicationId}/versions`, entity, requestConfig);
    }
    readVersion(versionId, requestConfig) {
        return this.get(`/versions/${versionId}`, requestConfig);
    }
    updateVersion(versionId, entity, requestConfig) {
        return this.put(`/versions/${versionId}`, entity, requestConfig);
    }
    getVersionUpgradeDetails(versionId, fromVersionIds, requestConfig) {
        return this.get(`/versions/${versionId}/upgrades`, {
            ...requestConfig,
            params: { versionIds: fromVersionIds.join(',') },
        });
    }
}
//# sourceMappingURL=application.js.map